export default "__VITE_ASSET__55e114f8__"